<p-card header="Create Incident Report">
  <app-dynamic-form [formFields]="witnessReportFields()" [formData]="witnessReportFormData()" [formKey]="getFormKey()" (submit)="createReport($event)" [disableSubmit]="submittingReport()" ></app-dynamic-form>
  @if (submitError()) {
    <div class="container mt-2">
      <div class="alert alert-danger" role="alert">
        <strong>There was a problem submitting your report.</strong>
        <br>
          <br>
            @if (!showErrDetails()) {
              <button type="button" class="btn btn-link" (click)="showErrorDetails()">Technical Details</button>
            }
            @if (showErrDetails()) {
              <div>
                <button *ngxClipboardIfSupported ngxClipboard [cbContent]="submitError()" (cbOnSuccess)="onErrorCopied()" class="btn btn-outline-secondary">Copy Details</button>
                @if (errorCopied()) {
                  <span class="ms-1">Details copied to clipboard!</span>
                }
                <pre class="json-display">{{submitError()}}</pre>
              </div>
            }
          </div>
        </div>
      }
    </p-card>
